'use client';

import type { ComponentProps } from 'react';
import { useDocsPage } from './..';
import { cn } from '../../../../lib/cn';

export function Container(props: ComponentProps<'article'>) {
  const { full } = useDocsPage();

  return (
    <article
      id="nd-page"
      data-full={full}
      {...props}
      className={cn(
        'flex flex-col w-full max-w-[960px] mx-auto [grid-area:main] px-4 py-6 gap-4 md:px-8 md:pt-10 xl:px-10 xl:pt-14',
        full && 'max-w-[1280px]',
        props.className,
      )}
    >
      {props.children}
    </article>
  );
}
